<template>
  <b-container fluid class="headerPushDown">
    <b-container class=" ml-auto mr-auto">  
    <!-- Show SHOP CATEGORIES -->
    <shop-categories-panel :searchTag="'ShowOnFrontPage'"/>   

    <!-- Top WelcomePanel -->
    <shop-icon-panel/>


    <!--  <shop-recomendations-panel/> --> 
   </b-container> 
  </b-container>  
</template>
<script>
// @ is an alias to /src
import ShopCategoriesPanel from '@/components/ShopCategoriesPanel'
/* import ShopRecomendationsPanel from '@/components/ShopRecomendationsPanel' */
import ShopIconPanel from '@/components/ShopIconPanel'

export default {
  name: 'shopIndex',
  components: {  
    ShopCategoriesPanel,
    /* ShopRecomendationsPanel, */
    ShopIconPanel, 
  },
  computed: {
        getSelectedLanguage() {
            return this.$store.getters.getLanguage;
        },
        getLanguageItem: function() { 
          return this.$store.getters.getLanguageStrings;
        },    
  },
 
}
</script>
